import { render, staticRenderFns } from "./task_step4.vue?vue&type=template&id=395de43e&scoped=true"
import script from "./task_step4.vue?vue&type=script&lang=js"
export * from "./task_step4.vue?vue&type=script&lang=js"
import style0 from "./task_step4.vue?vue&type=style&index=0&id=395de43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395de43e",
  null
  
)

export default component.exports